import React, { useState, useEffect } from "react";
import axios from "axios";
import "semantic-ui-css/semantic.min.css";
import { useAuth } from "../../../hook/userAuth";
import { Navigate, Link, useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { BASE_API } from "../../../ruta-server/BaseApi";
import { Loader, Button } from "semantic-ui-react";
import { TableAlumnos } from "../../../components/Alumnos/TableAlumnos/TableAlumnos";
import { ToastContainer, toast } from "react-toastify";
import Swal from "sweetalert2";
import ExcelJS from "exceljs"; // Importa la librería ExcelJS
import { saveAs } from "file-saver";

function AlumnosGrupo() {
  const { auth } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const datosGrupo = location.state?.datosGrupo;

  useEffect(() => {
    if (!datosGrupo) {
      navigate("/Grupos");
    }
  }, [datosGrupo, navigate]);

  if (!auth?.me?.es_personal_control_escolar) {
    return <Navigate to={"/"} />;
  }

  return datosGrupo ? <LogicaAlumnosGrupo datosGrupo={datosGrupo} /> : null;
}

function LogicaAlumnosGrupo({ datosGrupo }) {
  const { auth } = useAuth();
  const navigate = useNavigate();
  const [refetch, setRefetch] = useState(false);
  const [alumnosGrupo, setAlumnosGrupo] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function fetchAlumnosGrupo() {
      try {
        setLoading(true);
        const response = await axios.get(`${BASE_API}/api/grupo/`, {
          headers: {
            Authorization: `Bearer ${auth.token}`,
          },
        });

        const grupos = response.data;
        const grupo = grupos.find(
          (grupo) => grupo.id_grupo === datosGrupo.id_grupo
        );
        if (grupo) {
          const alumnosIds = grupo.alumnos;
          const alumnosResponse = await Promise.all(
            alumnosIds.map(async (alumnoId) => {
              const response = await axios.get(
                `${BASE_API}/api/alumno/${alumnoId}/`,
                {
                  headers: {
                    Authorization: `Bearer ${auth.token}`,
                  },
                }
              );
              return response.data;
            })
          );

          // Ordenar los alumnos por apellidos antes de almacenarlos
          alumnosResponse.sort((a, b) => {
            if (a.apellido < b.apellido) return -1;
            if (a.apellido > b.apellido) return 1;
            return 0;
          });

          setAlumnosGrupo(alumnosResponse);
          setLoading(false);
        } else {
          setLoading(false);
        }
      } catch (error) {
        setLoading(false);
        window.location.reload();
        window.location.href = "/Login";
        console.error("Error al obtener alumnos del grupo:", error);
      }
    }

    fetchAlumnosGrupo();
  }, [auth.token, datosGrupo.id_grupo, refetch]);

  const onRefetch = () => {
    setRefetch((prev) => !prev);
  };

  async function getGrupoActualDelAlumno(alumnoId) {
    try {
      const response = await axios.get(`${BASE_API}/api/grupo/`, {
        headers: {
          Authorization: `Bearer ${auth.token}`,
        },
      });
      const grupos = response.data;
      const grupoActual = grupos.find((grupo) =>
        grupo.alumnos.includes(alumnoId)
      );
      console.log("Grupo actual", grupoActual);

      return grupoActual;
    } catch (error) {
      window.location.reload();
      window.location.href = "/Login";
      console.error(error);
      throw error;
    }
  }

  async function eliminarAlumnoDelGrupoAntiguo(alumnoId) {
    try {
      // Obtener el grupo actual del alumno
      const grupoActual = await getGrupoActualDelAlumno(alumnoId);

      // Verificar si el grupo actual está definido
      if (grupoActual && grupoActual.id_grupo) {
        // Eliminar al alumno del grupo actual
        const url = `${BASE_API}/api/grupo/${grupoActual.id_grupo}/`; // URL del grupo actual
        const headers = {
          Authorization: `Bearer ${auth.token}`,
          "Content-Type": "application/json",
        };
        const alumnosIdsActualizados = grupoActual.alumnos.filter(
          (id) => id !== alumnoId
        );
        const data = {
          ...grupoActual,
          alumnos: alumnosIdsActualizados,
        };
        await axios.put(url, data, { headers });
        onRefetch();
      } else {
        console.error("No se pudo obtener el grupo actual del alumno.");
      }
    } catch (error) {
      window.location.reload();
      window.location.href = "/Login";
      console.error(error);
      throw error;
    }
  }

  async function bajaTemporalAlmuno(data) {
    const confirmMessage = data.matricula
      ? `¿Seguro que desea dar de baja al alumno con matrícula: ${data.matricula}?`
      : data.curp
      ? `¿Seguro que desea dar de baja del grupo al alumno con CURP: ${data.curp}?`
      : "No se proporcionó matrícula ni CURP";

    const result = await Swal.fire({
      text: confirmMessage,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Baja temporal",
      confirmButtonColor: "#d09306",
      cancelButtonText: "Cancelar",
      cancelButtonColor: "#8c8c8c",
      showDenyButton: true,
      denyButtonText: "Baja definitiva",
      denyButtonColor: "#920804",
      reverseButtons: true,
    });

    if (!result.isConfirmed && !result.isDenied) return;

    const actionType = result.isConfirmed ? "Baja temporal" : "Baja definitiva";
    eliminarAlumnoDelGrupoAntiguo(data.id);
    console.log(`${data.id} dando de baja ${actionType}`);

    try {
      const url = `${BASE_API}/api/alumno/${data.id}/`;
      const headers = {
        Authorization: `Bearer ${auth.token}`,
        "Content-Type": "application/json",
      };

      const newData = {
        estado_alumno:
          actionType === "Baja temporal" ? "Baja temporal" : "Baja definitiva",
      };

      const response = await axios.patch(url, newData, { headers });
      const successMessage =
        actionType === "Baja temporal"
          ? "Alumno dado de baja temporal exitosamente"
          : "Alumno dado de baja definitiva exitosamente";
      toast.success(successMessage);
      return response.data;
    } catch (error) {
      if (error.response && error.response.status === 400) {
        if (error.response.data.numero_grupo !== undefined) {
          toast.error(
            "campo de descripción: " + error.response.data.numero_grupo[0]
          );
        }
      }
      throw error;
    }
  }

  const generateExcel = async () => {
    try {
      const excelTemplateResponse = await axios.get(
        `${BASE_API}/api/alumno-data-template/`, // Endpoint para obtener el archivo de plantilla de Excel
        {
          responseType: "arraybuffer", // Cambia la responseType a arraybuffer para recibir un array de bytes
          headers: {
            Authorization: `Bearer ${auth.token}`,
          },
        }
      );

      const excelData = excelTemplateResponse.data;

      // Crear un nuevo libro de Excel
      const workbook = new ExcelJS.Workbook();
      await workbook.xlsx.load(excelData);

      // Obtener la hoja de trabajo
      const worksheet = workbook.getWorksheet("Sheet1");

      // Obtener el estilo de la fila 3
      const templateRow = worksheet.getRow(3);

      // Ordenar los alumnos por apellido paterno, luego por apellido materno, y finalmente por nombre
      const alumnosOrdenados = [...alumnosGrupo].sort((a, b) => {
        const compareApellidoPaterno = a.apellido_paterno.localeCompare(
          b.apellido_paterno
        );
        if (compareApellidoPaterno !== 0) return compareApellidoPaterno;

        const compareApellidoMaterno = a.apellido_materno.localeCompare(
          b.apellido_materno
        );
        if (compareApellidoMaterno !== 0) return compareApellidoMaterno;

        return a.nombre.localeCompare(b.nombre);
      });

      // Definir las claves de los atributos del alumno y los índices de las celdas
      const attributeKeys = [
        "matricula",
        "semestre",
        "alumno_traslado",
        "apellido_paterno",
        "apellido_materno",
        "nombre",
        "fecha_nacimiento",
        "curp",
        "edad",
        "sexo",
        "nacionalidad",
        "lugar_nacimiento",
        "calle_domicilio",
        "numero_domicilio",
        "colonia_domicilio",
        "municipio_domicilio",
        "estado_domicilio",
        "codigo_postal_domicilio",
        "telefono_casa",
        "telefono_celular",
        "email",
        "tipo_sanguineo",
        "discapacidad",
        "descripcion_discapacidad",
        "lengua_indigena",
        "descripcion_lengua_indigena",
        "planel_procedencia",
        "clave_plantelProc",
        "promedio_plantel_procedencia",
        "servicio_medico",
        "num_afiliacion",
        "trabajo_activo",
        "descripcion_trabajo",
        "dependencia_economica",
        "descripcion_dependencia",
        "apellido_paterno_tutor",
        "apellido_materno_tutor",
        "nombre_tutor",
        "calle_domicilio_tutor",
        "numero_domicilio_tutor",
        "colonia_domicilio_tutor",
        "municipio_domicilio_tutor",
        "estado_domicilio_tutor",
        "codigo_postal_domicilio_tutor",
        "telefono_casa_tutor",
        "telefono_celular_tutor",
        "email_tutor",
        "fecha_baja_temporal_1",
        "fecha_baja_temporal_2",
        "fecha_baja_definitiva",
      ];

      // Desplazar filas hacia abajo para hacer espacio para nuevas filas de alumnos
      const numAlumnos = alumnosOrdenados.length;
      worksheet.spliceRows(4, 1, ...Array(numAlumnos).fill([]));

      // Modificar las celdas según sea necesario usando alumnosOrdenados
      let rowIndex = 3; // Comenzar en la fila 3
      alumnosOrdenados.forEach((alumno) => {
        const row = worksheet.getRow(rowIndex);
        attributeKeys.forEach((key, index) => {
          const cell = row.getCell(index + 1);
          if (key === "alumno_traslado") {
            cell.value = alumno[key] ? "Sí" : "No"; // Asignar "Sí" o "No" según el valor booleano
          } else {
            cell.value = alumno[key] || " ";
          }
          cell.style = templateRow.getCell(index + 1).style; // Copiar el estilo de la celda
        });

        rowIndex++; // Avanzar a la siguiente fila para el siguiente alumno
      });

      // Guardar el libro de Excel
      const excelBuffer = await workbook.xlsx.writeBuffer();
      saveAs(
        new Blob([excelBuffer]),
        `AlumnosGrupo_${datosGrupo.numero_grupo}.xlsx`
      );
    } catch (error) {
      console.error("Error al generar el archivo Excel:", error);
      toast.error("Error al generar el archivo Excel");
    }
  };

  const updateAlumno = async (data, datosGrupo) => {
    navigate("/Grupos/AlumnosGrupo/DatosAlumno", {
      state: { datosAlumno: data, datosG: datosGrupo },
    });
  };

  return (
    <>
      <h1 className="tituloin">GRUPO {datosGrupo.numero_grupo}</h1>
      <h6 className="sub">
        <Link to="/Grupos">Grupos</Link>/ Grupo {datosGrupo.numero_grupo}{" "}
      </h6>
      {loading ? (
        <Loader active inline="centered">
          Cargando....
        </Loader>
      ) : (
        <TableAlumnos
          grupo={datosGrupo}
          alumnos={alumnosGrupo}
          bajaTemporalAlumno={bajaTemporalAlmuno}
          updateAlumno={updateAlumno}
          datosGrupo={datosGrupo}
        />
      )}
      {alumnosGrupo?.length > 0 && (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            paddingBottom: "12px",
          }}
        >
          <Button
            icon="file excel"
            content="Descargar datos"
            onClick={generateExcel}
            className="descarga"
          />
        </div>
      )}
      <ToastContainer />
    </>
  );
}

export default AlumnosGrupo;
